import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { GlobalErrorHandlerService } from './shared/global-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
    })),
   provideAnimationsAsync(), provideHttpClient(withInterceptorsFromDi()), 
{provide: ErrorHandler, useClass: GlobalErrorHandlerService}],
};
